import { render, staticRenderFns } from "./AppBody.vue?vue&type=template&id=36fe2fb8"
import script from "./AppBody.vue?vue&type=script&lang=js"
export * from "./AppBody.vue?vue&type=script&lang=js"
import style0 from "./AppBody.vue?vue&type=style&index=0&id=36fe2fb8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports